import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EncuestaService } from 'src/app/servicios/encuesta.service';

@Component({
  selector: 'app-dialog-copiar-encuesta',
  templateUrl: './dialog-copiar-encuesta.component.html',
  styleUrls: ['./dialog-copiar-encuesta.component.css']
})
export class DialogCopiarEncuestaComponent implements OnInit {
  encuestas = [];
  loadingEncuesta = false;
  encuestaCopiar = {};
  nombreEncuesta = '';
  idEncuesta = '';
  loadingDetalle = false;
  showBtn = 0;
  isDetail = false;
  numeroPregunta = 0;

  constructor(private encuestaService: EncuestaService) {}

  ngOnInit() {
    this.obtenerEncuestas();
  }

  obtenerEncuestas() {
    this.loadingEncuesta = true;
    this.encuestaService.getEncuestas().subscribe(data => {
      this.encuestas = data;
      this.loadingEncuesta = false;
    });
  }

  selectEncuesta(encuesta) {
    this.loadingDetalle = true;
    //console.log(JSON.stringify(encuesta));
    this.nombreEncuesta = encuesta.valor;
    this.idEncuesta = encuesta.id;
    this.encuestaService.getEncuestaCopiar(encuesta.id).subscribe(datos => {
      this.isDetail = true;
      this.encuestaCopiar = datos;
      this.loadingDetalle = false;
      //console.log(JSON.stringify(this.encuestaCopiar));
    });
  }

  selectEdit(event: Event) {
    event.stopPropagation();
    console.log('select edit');
  }

  mouseHover(id) {
    //console.log('hover');
    this.showBtn = id;
  }

  mouseOut() {
    this.showBtn = 0;
    //console.log('out');
  }

  volver() {
    this.nombreEncuesta = '';
    this.idEncuesta = '';
    this.isDetail = false;
  }

  copiarEncuesta() {
    alert(this.idEncuesta);
  }
}
